import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@boltmodular.in");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data?.token) localStorage.setItem("bm_token", data.token);
      localStorage.setItem("bm_user", JSON.stringify({ email: data.email, name: data.name, role: data.role }));
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F4] grid place-items-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 justify-center mb-10">
          <div className="w-12 h-12 rounded-sm bg-[#8C5931] text-[#F9F8F4] grid place-items-center font-serif text-xl">BM</div>
          <div className="leading-tight">
            <div className="font-serif text-xl text-[#2B2623]">Bolt Modular</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#6E6862]">Admin Console</div>
          </div>
        </Link>

        <form onSubmit={submit} data-testid="admin-login-form" className="bg-white border border-[#E5E0D5] p-8 md:p-10 space-y-5">
          <div className="flex items-center gap-3 mb-2">
            <Lock size={18} className="text-[#8C5931]"/>
            <h1 className="font-serif text-2xl">Sign in</h1>
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#6E6862]">Email</label>
            <input data-testid="admin-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="mt-2 w-full bg-transparent border-b border-[#8C5931]/30 py-3 outline-none focus:border-[#8C5931] text-[#2B2623]" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#6E6862]">Password</label>
            <input data-testid="admin-password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} className="mt-2 w-full bg-transparent border-b border-[#8C5931]/30 py-3 outline-none focus:border-[#8C5931] text-[#2B2623]" />
          </div>
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full bg-[#2B2623] text-[#F9F8F4] py-4 rounded-full hover:bg-[#8C5931] transition-colors disabled:opacity-60">
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
        <p className="text-center text-xs text-[#6E6862] mt-6">Authorised personnel only.</p>
      </div>
    </div>
  );
}
